import authorizedAxios from "../../helpers/authorizedAxios";
import { showToast, showAlert } from "../../utils/helpers/ShowToast";
import { getActiveOutletId } from "../../utils/helpers/outletContext";

export const SET_SELLER_STOCKS = "SET_SELLER_STOCKS";
export const SET_SELLER_STOCKS_LOADING = "SET_SELLER_STOCKS_LOADING";
export const SET_SELLER_STOCKS_ERROR = "SET_SELLER_STOCKS_ERROR";
export const SET_SELLER_STOCKS_SAVING = "SET_SELLER_STOCKS_SAVING";

let latestRequest = 0;
export const fetchSellerStocks = (params = {}) => async (dispatch) => {
  const request = ++latestRequest;
  const outletId = getActiveOutletId();
  const isCurrent = () => request === latestRequest && outletId === getActiveOutletId();
  dispatch({ type: SET_SELLER_STOCKS_LOADING, value: true });
  try {
    const [response, history] = await Promise.all([
      authorizedAxios.get("/seller-stocks", { params }),
      authorizedAxios.get("/seller-stocks/history", { params: { page: params.historyPage || 1 } }),
    ]);
    if (isCurrent()) dispatch({ type: SET_SELLER_STOCKS, value: { ...response.data.data, history: history.data.data } });
  } catch (error) {
    if (isCurrent()) dispatch({ type: SET_SELLER_STOCKS_ERROR, value: error?.response?.data?.message || "Stok seller belum dapat dimuat." });
  } finally {
    if (isCurrent()) dispatch({ type: SET_SELLER_STOCKS_LOADING, value: false });
  }
};

export const getSellerStockDetail = (id) => async () => {
  const outletId = getActiveOutletId();
  try {
    const response = await authorizedAxios.get(`/seller-stocks/${id}`);
    return outletId === getActiveOutletId() ? response.data.data : null;
  } catch (error) {
    showAlert({ type: "error", message: error?.response?.data?.message || "Detail belum dapat dimuat." });
    return null;
  }
};

const save = (request, loading, success) => async (dispatch) => {
  dispatch({ type: SET_SELLER_STOCKS_SAVING, value: true });
  try {
    await showToast(request(), { loading, success, error: (error) => error?.response?.data?.message || "Stok seller gagal diperbarui." });
    return true;
  } catch (_error) {
    return false;
  } finally {
    dispatch({ type: SET_SELLER_STOCKS_SAVING, value: false });
  }
};

export const createSellerStockDocument = (data) => save(() => authorizedAxios.post("/seller-stocks", data), "Mencatat stok seller...", "Dokumen stok seller berhasil dicatat.");
export const processSellerStockDocument = (id, action) => save(() => authorizedAxios.post(`/seller-stocks/${id}/${action}`), "Memproses dokumen...", "Stok seller berhasil diperbarui.");
